export var PlayTriggersEnum;
(function (PlayTriggersEnum) {
    PlayTriggersEnum["PLAY_TRIGGER_CLICK"] = "clickplay";
    PlayTriggersEnum["PLAY_TRIGGER_CLICK_REC"] = "clickplay_rec";
    PlayTriggersEnum["PLAY_TRIGGER_SWIPE_RIGHT"] = "swipeplay_right";
    PlayTriggersEnum["PLAY_TRIGGER_SWIPE_LEFT"] = "swipeplay_left";
    PlayTriggersEnum["PLAY_TRIGGER_AUTOPLAY"] = "autoplay";
    PlayTriggersEnum["PLAY_TRIGGER_HOVERPLAY"] = "hoverplay";
})(PlayTriggersEnum || (PlayTriggersEnum = {}));
/**
 * URL param used to generate share link. Can be used
 * as a fragment or query param.
 *
 * E.g.
 * - `https://example.com/watch?v=123#fwplayer=base64`
 * - `https://example.com/watch?v=123&fwplayer=base64`
 */
export const SHARE_LINK_PARAM = 'fwplayer';
export var TrackingEventName;
(function (TrackingEventName) {
    TrackingEventName["CONFIRM_PAYMENT_INTENT"] = "commerce:confirm_payment_intent";
})(TrackingEventName || (TrackingEventName = {}));
